import { createContext } from 'preact'

type FileUploadContext = (_file: any) => void

const SeamlyFileUploadContext = createContext<FileUploadContext | null>(null)

export default SeamlyFileUploadContext
